import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { evaluationApi, EvaluationHistoryItem } from '../../services/evaluationApi';
import styles from './employees.module.css';

export function EvaluationsTab({ employeeId }: { employeeId: string }) {
  const navigate = useNavigate();
  const [history, setHistory] = useState<EvaluationHistoryItem[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    (async () => {
      try {
        const data = await evaluationApi.getEmployeeEvaluationHistory(employeeId);
        setHistory(data);
      } catch (e: any) {
        setError(e.message || 'Failed to load evaluation history');
      } finally {
        setLoading(false);
      }
    })();
  }, [employeeId]);

  if (loading) return <div className={styles.loadingText}>Loading evaluation history...</div>;
  if (error) return <div className={styles.errorText}>{error}</div>;
  if (history.length === 0) return <div style={{ padding: 20, color: '#6B7885', fontSize: 14 }}>No completed evaluations found.</div>;

  const formatDate = (d: string | null) => d ? new Date(d).toLocaleDateString('en-GB') : '\u2014';

  const formatCycleType = (t: string) => {
    if (t === 'MidYearReview') return 'Mid-Year Review';
    if (t === 'ProbationReview') return 'Probation Review';
    return 'Year-End Evaluation';
  };

  const formatStatus = (s: string) => {
    if (s === 'Acknowledged') return 'Complete';
    if (s === 'ManagerCompleted') return 'Pending Acknowledgement';
    return s;
  };

  const statusColor = (s: string) => {
    if (s === 'Acknowledged') return '#059669';
    if (s === 'ManagerCompleted') return '#D97706';
    return '#6B7280';
  };

  return (
    <div>
      <table className={styles.table}>
        <thead>
          <tr>
            <th>Cycle</th>
            <th>Type</th>
            <th>Year</th>
            <th>Status</th>
            <th>Overall Rating</th>
            <th>Manager Completed</th>
            <th>Acknowledged</th>
          </tr>
        </thead>
        <tbody>
          {history.map(h => (
            <tr key={h.evaluationId} onClick={() => navigate(`/evaluations/${h.evaluationId}`)} style={{ cursor: "pointer" }}>
              <td style={{ fontWeight: 600, color: '#0A2240' }}>{h.cycleName}</td>
              <td>{formatCycleType(h.cycleType)}</td>
              <td>{h.reviewYear}</td>
              <td><span style={{ color: statusColor(h.status), fontWeight: 600 }}>{formatStatus(h.status)}</span></td>
              <td style={{ fontWeight: 600 }}>{h.overallRating || '\u2014'}</td>
              <td>{formatDate(h.managerCompletedAt)}</td>
              <td>{formatDate(h.employeeAcknowledgedAt)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
